<template>
  <form action="https://api.staticforms.xyz/submit" method="post">
    <span>Entre em contato por e-mail solicitando nossos serviços.</span>
    <div class="input-container">
      <input type="text" name="name" placeholder="Nome/Empresa" required />
      <input type="email" name="email" placeholder="Seu e-mail" required />
      <input type="text" name="honeypot" style="display:none" />
      <input type="hidden" name="accessKey" value="87a5a202-3873-4db5-bb25-7cef7812177b"/>
      <input type="hidden" name="subject" value="Contato - SAMATech" />
      <input type="hidden" name="replyTo" value="@" />
      <input type="hidden" name="redirectTo" :value="pageURL + '?form=ok'" />
      <input type="submit" value="Enviar">
    </div>
  </form>
</template>

<style lang="scss" scoped>
form {
  display: flex;
  background: url("~@/assets/img/sample-2.jpg");
  background-position-y: bottom;
  background-size: cover;
  padding: 2em 1em;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 900px) {
    flex-direction: column;
  }
}
span {
    display: inline-block;
    font-family: $fonts-title;
    font-size: 1.2rem;
    color: white;
    display:block;
    margin-right: 1em;
    @media screen and (max-width: 900px) {
      text-align: center;
      margin-bottom: 1em;
      margin-right: 0;
    } 
}
.input-container {
  display: flex;
  justify-content: center;
  @media screen and (max-width: 500px) {
    flex-direction: column;
    input {
      width: 100%;
      margin-top: 2px;
      &[type="submit"] {
        margin-top: 4px;
      }
    }
  }
}
[type="text"],[type="email"] {
  box-sizing: border-box;
  border-radius: 2px;
  box-shadow: none;
  padding: 0.4em;
  border: none;
  width: 120px;
  flex-shrink: 1;
  margin-right: 3px;
}
[type="email"] {
  width: 170px;
}
[type="submit"] {
  color: white;
  background: #54bd6f;
  border: 0;
  padding: 0.5em;
  border-radius: 2px;
  width: 90px;
  cursor: pointer;
}
</style>

<script>
export default {
  computed: {
    pageURL() {
      return document.location.href;
    }
    
  }
}
</script>